import { useContext } from "react";
import { ThemeContext } from "../../ThemeContext";
import { useAppTranslation } from "../../Utils/useAppTranslation";
import "./ThemeToggle.css";

const ThemeToggle = () => {
  const { theme, changeTheme, themes } = useContext(ThemeContext);
  const { i18n } = useAppTranslation();
  const currentLng = i18n.language;

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  // return (
  //   <div
  //     style={{
  //       display: "flex",
  //       gap: "10px",
  //       padding: "5px",
  //       justifyContent: "end",
  //       position:"absolute",
  //       right: '0'
  //     }}
  //   >
  //     {themes.map((t, i) => (
  //       <div
  //         key={t}
  //         style={{
  //           width: "15px",
  //           height: "15px",
  //           borderRadius: "50%",
  //           backgroundColor:
  //             themes[i] === "light"
  //               ? "white"
  //               : themes[i] === "dark"
  //               ? "black"
  //               : themes[i],
  //           cursor: "pointer",
  //           border: "2px solid #ffff", // Highlight selected theme
  //         }}
  //         onClick={() => changeTheme(t)}
  //       />
  //     ))}
  //     {/* <div className="hinEngDiv">
  //       {currentLng === "hi" ? (
  //         <button onClick={() => changeLanguage("en")} className="hineng">
  //           In English
  //         </button>
  //       ) : (
  //         <button onClick={() => changeLanguage("hi")} className="hineng">
  //           हिन्दी में
  //         </button>
  //       )}
  //     </div> */}
  //   </div>
  // );
};

export default ThemeToggle;
